import { render, staticRenderFns } from "./ViewImportComponent.vue?vue&type=template&id=55ea2ac0"
import script from "./ViewImportComponent.vue?vue&type=script&lang=js"
export * from "./ViewImportComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports